import { Factory, FlaskConical, Globe2, Leaf, MapPin, Sparkles } from "lucide-react";
import { cdmo } from "@/content/site";
import { Reveal } from "@/components/motion/Reveal";
import { SectionHeader } from "@/components/common/SectionHeader";

const ROUTE_ICONS = { domestic: MapPin, export: Globe2 };
const CATEGORY_ICONS = { pharma: FlaskConical, cosmetics: Sparkles, supplements: Leaf };

// SPC's network of qualified CDMOs in India for licensed products.
export const CdmoSection = () => (
  <section className="section-y border-t border-line" data-testid="cdmo-section">
    <div className="container-x grid gap-12 lg:grid-cols-12">
      <div className="lg:col-span-5">
        <SectionHeader eyebrow={cdmo.eyebrow} title={cdmo.title} body={cdmo.body} />
        <Reveal delay={0.1} className="mt-8 flex flex-wrap gap-2" data-testid="cdmo-categories">
          {cdmo.categories.map((c) => {
            const Icon = CATEGORY_ICONS[c.id];
            return (
              <span key={c.id} className="inline-flex items-center gap-2 rounded-none border border-line bg-surface px-4 py-2 text-[14px] text-ink">
                <Icon className="h-4 w-4 text-accent" strokeWidth={1.5} /> {c.label}
              </span>
            );
          })}
        </Reveal>
      </div>
      <div className="grid gap-5 sm:grid-cols-2 sm:items-start lg:col-span-7 lg:pt-16">
        {cdmo.routes.map((r, i) => {
          const Icon = ROUTE_ICONS[r.id];
          return (
            <Reveal key={r.id} delay={i * 0.1} className={`flex flex-col p-8 sm:p-10 ${i ? "bg-ink text-paper" : "border border-line bg-surface text-ink"}`} data-testid={`cdmo-route-${r.id}`}>
              <div className="flex items-center gap-3">
                <Factory className={`h-6 w-6 ${i ? "text-paper/80" : "text-accent"}`} strokeWidth={1.4} />
                <Icon className={`h-6 w-6 ${i ? "text-paper/80" : "text-accent"}`} strokeWidth={1.4} />
              </div>
              <h3 className="mt-8 font-display text-3xl font-semibold leading-tight tracking-[-0.03em]">{r.title}</h3>
              <p className={`mt-4 text-[15px] leading-relaxed ${i ? "text-paper/80" : "text-muted"}`}>{r.body}</p>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
